import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class LprCameraModel extends SnModel {
  @Expose({ name: 'camera_id' })
  public id: string;

  @Expose()
  public pk: string;

  @Expose()
  public name: string;

  @Expose()
  public provider: string;

  @Expose()
  public latitude: number;

  @Expose()
  public longitude: number;

  @Expose()
  public heading: number;

  @Expose({ name: 'last_event' })
  public lastEvent: string;

  @Expose({ name: 'last_created' })
  public lastCreated: string;

  @Expose()
  public editable: string[];

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }

  get geometry(): any {
    if (!this.longitude || !this.latitude) {
      return null;
    }
    return {
      type: 'Point',
      coordinates: [this.longitude, this.latitude],
    };
  }
}
